export default __webpack_public_path__ + "static/media/servisor-logo-orange.dab3ad49.svg";